import { settings } from '../../settings';

const state = {
    locale: settings.default_locale,
}

// getters
const getters = {
    app_locale: (state) => {
        return state.locale;
    },
    locale: (state) => {
        return state.locale == 'no' ? 'nb-NO' : 'en-US';
    },
    language: (state) => {
        return settings.languages.find(obj => {
            return obj.locale === state.locale
        });
    },
    languages: () => {
        return settings.languages;
    }
}

// actions
const actions = {
    change_locale({ commit }, locale) {
        commit('set_locale', { locale: locale })
    }
}

// mutations
const mutations = {
    set_locale(state, { locale }) {
        state.locale = locale;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
